var map = {
	"./techBatteryPack.jpg": "ee39",
	"./techBatteryPack_EN.jpg": "b3b4",
	"./techIot.jpg": "adaf",
	"./techIot_EN.jpg": "56ce",
	"./techSFC.jpg": "fdb8",
	"./techSFC_EN.jpg": "37f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec74";